<template>
  <form @submit.prevent="onSubmit">
    <!--    <elsa-v-select-->
    <!--      class="mb-4"-->
    <!--      :options="categories"-->
    <!--      v-model="category"-->
    <!--      label="name"-->
    <!--      :reduce="item => item.id"-->
    <!--      :append-to-body="true"-->
    <!--      :clearable="false"-->
    <!--      html-label="Тип"-->
    <!--    />-->

    <vs-input
      class="w-full mb-4"
      label="Номер телефона"
      v-model="data.contact"
    />

    <vs-input
      class="w-full mb-4"
      label="Доп. инфо"
      v-model="data.description"
    />

    <div class="mb-4">
      <vs-checkbox v-model="data.is_callable">
        Кнопка «Позвонить»
      </vs-checkbox>
    </div>

    <div class="text-center">
      <vs-button
        id="contactsPhoneFormModalButton"
        class="vs-con-loading__container"
        button="submit"
        color="success"
        type="border"
      >
        Добавить
      </vs-button>
    </div>
  </form>
</template>

<script>
import mergeCommonErrors from "@/helpers/mergeCommonErrors";
import modalContext      from "@/mixins/modalContext";
import notifyHttpError   from "@/mixins/notifyHttpError";

const formFields = [
  'contact',
  'description',
  'is_callable',
];

export default {
  name:   "UCContactsPhoneFormModal",
  props:  ['onSave', 'phone'],
  mixins: [notifyHttpError, modalContext],
  data() {
    return {
      data:    {
        contact:     this.phone ? this.phone.contact : '',
        description: this.phone ? this.phone.description : '',
        is_callable: this.phone ? this.phone.is_callable : false,
      },
      errors:  {},
      loading: false,
    };
  },
  methods: {
    updateLoading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#contactsPhoneFormModalButton',
          scale:     .5,
        });

      } else {
        this.$vs.loading.close('#contactsPhoneFormModalButton > .con-vs-loading');
      }
    },

    onSubmit() {
      if (this.loading) return;

      this.loading = true;
      this.onSave(this.data).then(
        () => this.modalResolve(),
        ( error ) => {
          const { response: { data } } = error;
          this.errors = mergeCommonErrors(data.errors, formFields);
          if (this.errors.common) this.notifyHttpError(error);
        },
      ).finally(() => this.loading = false);
    },
  },
  watch:   {
    loading() {
      this.updateLoading();
    },
  },
};
</script>

<style scoped>

</style>
